var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_40",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m50.04,54.42c-.243.001-.476-.098-.644-.273l-27.805-27.806c-.266-.259-.349-.655-.207-.998.142-.344.479-.567.85-.563h55.531c.372-.004.709.219.85.563s.06.739-.206.998l-27.718,27.806c-.171.175-.406.274-.651.273h0Zm-25.601-27.814l25.601,25.609,25.496-25.609H24.439Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m49.927,90.65c-.503-.005-.909-.414-.909-.918l.064-36.23c-.002-.241.092-.472.261-.643.169-.171.4-.266.64-.266.502,0,.909.407.909.909l-.056,36.23c0,.504-.406.913-.909.918h0Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m60.879,90.65h-21.915c-.471-.045-.831-.44-.831-.914s.36-.869.831-.914h21.915c.472.044.832.44.832.914s-.36.869-.832.914Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "1.5px",
        },
        attrs: { x1: "33.326", y1: "36.333", x2: "46.248", y2: "36.333" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "1.5px",
        },
        attrs: { x1: "56.715", y1: "36.333", x2: "66.563", y2: "36.333" },
      }),
      _c("ellipse", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "1.5px",
        },
        attrs: {
          cx: "51.079",
          cy: "37.266",
          rx: "5.536",
          ry: "3.768",
          transform: "translate(-11.95 32.254) rotate(-31.567)",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "46.396", y1: "44.98", x2: "48.253", y2: "41.857" },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "53.765", y1: "32.586", x2: "65.203", y2: "13.35" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }